import React from 'react';

import Layout from '@source/components/Layout';
import { IRegionProps } from '@source/interface';
import HeadMeta from '@source/pages/Home/components/HeadMeta/HeadMeta';

import AboutCarro from './components/AboutCarro';
import AboutInTheNews from './components/AboutInTheNews';
import AboutBanner from './components/AboutBanner';
// import AboutBannerAds from './components/AboutBanerAds';

const AboutUs = ({ region }: IRegionProps) => (
  <Layout bannerContent={<AboutBanner />} hideSocialChat={false}>
    <HeadMeta metaKey="about" region={region} />

    <AboutCarro region={region} />

    {region !== 'hk' && <AboutInTheNews />}

    {/* <AboutBannerAds
      title="We’re Always Looking Out For Talented Individuals"
      subtitle="We have 3 offices around the globe and we’re looking for great people to join us! Do you have what it takes?"
      linkText="SEE OUR JOBS OPENING"
      linkUrl="https://careers.carro.sg"
    /> */}
  </Layout>
);

export default AboutUs;
